import React, { useEffect, useState } from "react"
import { useForm, Controller } from "react-hook-form"
import { z } from "zod"
import { zodResolver } from "@hookform/resolvers/zod"
import axios from 'axios'
import { toast } from 'react-hot-toast';
import { MdHighlightOff, MdClose } from "react-icons/md";
import { useNavigate, useLocation } from "react-router-dom"

import { Header } from "../../components/Header"
import { ButtonContainer, Container, Content, FileContainer, Footer, FooterContainer, Form, InfoContainer, InputContainer, ParagraphContainer, SelectContainer, TitleContainer, ToastContainer, ToastText } from "./styles"
import { Typography } from "../../components/Typography"
import { Button } from "../../components/Button"

import { Input } from "../../components/Input"
import { isValidCPF } from "../../utils/validators"

function validateArrivalTime(arrivalTime, startTime) {
  const today = new Date()
  const formatedArrivalTime = arrivalTime.split(':')
  arrivalTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), formatedArrivalTime[0], formatedArrivalTime[1], 0)
  if (arrivalTime > new Date(startTime)) {
    return true
  }
  return false
}

const schema = z.object({
  storeId: z.string().nonempty("Código da loja é obrigatório.").regex(/^[0-9]+$/, "Deve conter apenas números").max(4, "Deve conter no máximo 4 números"),
  password: z.string().nonempty("Senha é obrigatória.").max(3, "Deve conter no máximo 3 números"),
  cpf: z.string().nonempty("CPF é obrigatório.").refine((value) => isValidCPF(value), "CPF inválido."),
  arrivalTime: z.string().nonempty("Horário de chegada é obrigatório.").regex(/^(?:[01][0-9]|2[0-3]):[0-5][0-9]$/, "Horário inválido" ).refine((value) => !validateArrivalTime(value, new Date()), { message: "Horário de chegada maior que o horário atual" }),
  startServiceTime: z.string().nonempty("Inicio do atendimento é obrigatório"),
  endServiceTime: z.string().nonempty("Fim do atendimento é obrigatório"),
}).refine((data) => {
  return !validateArrivalTime(data.arrivalTime, data.startServiceTime)
}, {
  message: "Horário de chegada maior que o início do atendimento",
  path: ["arrivalTime"]
})

function UnsubscribeScreen() {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    setError,
    getValues,
    clearErrors,
    formState: { errors, isSubmitting, },
  } = useForm({ resolver: zodResolver(schema), mode: "onBlur"})
  const location = useLocation();

  const [urlBackend, setUrlBackend] = useState()
  const navigate = useNavigate()

  const onSubmit = async (data) => {
    const today = new Date()
    const formatedArrivalTime = data.arrivalTime.split(':')

    const startTime = new Date(data.startServiceTime)
    const endTime = new Date(data.endServiceTime)
    let arrivalTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), formatedArrivalTime[0], formatedArrivalTime[1], 0)

    try {
      if (arrivalTime > startTime) {
        throw new Error("Horário de chegada maior que o início do atendimento")
      }

      const dados = `idLoja=${data.storeId}&numeroSenha=${data.password}&cpf=${data.cpf}&horaChegada=${data.arrivalTime}&horaInicioAtendimento=${startTime.getHours()}:${startTime.getMinutes()}&horaFimAtendimento=${endTime.getHours()}:${endTime.getMinutes()}`

      await axios.get(urlBackend + '/atendimento/saveCrefisa?'+ dados);

      navigate("/service-analysis/success")
    } catch (err) {
      toast(
        <ToastContainer> 
          <Typography style={{paddingTop: 10, paddingBottom: 10}} size="small" color="white">{err.message}</Typography>
          <MdClose size={24} color='white'/>
        </ToastContainer>,
        {
          icon: <MdHighlightOff size={24} color='white'/>,
          style: {
            background: '#F67D88',
            paddingLeft: '1rem',
            paddingRight: '1rem',
            paddingTop: 0,
            paddingBottom: '0.25rem',
            borderRadius: '0 0 0.5rem 0.5rem',
            color: 'white',
            width: '375px',
            margin: '0px'
          },
        }
      );
    }
  }

  function startService() {
    if (!watch('storeId') || errors.storeId) {
      setError("storeId", { message: errors.storeId ? errors.storeId.message : "Código da loja é obrigatório." })
      return
    }
    if (!watch('password') || errors.password) {
      setError("password", { message: errors.password ? errors.password.message : "Senha é obrigatório." })
      return
    }
    if (!watch('cpf') || errors.cpf) {
      setError("cpf", { message: errors.cpf ? errors.cpf.message : "CPF é obrigatório." })
      return
    }
    if (!watch('arrivalTime') || errors.arrivalTime) {
      setError("arrivalTime", { message: errors.arrivalTime ? errors.arrivalTime.message : "Horário de chegada é obrigatório." })
      return
    }
    if (validateArrivalTime(getValues('arrivalTime'),  new Date().toString())) {
      setError("arrivalTime", { message: "Horário de chegada maior que o início do atendimento" })
      return
    }
    clearErrors("arrivalTime")
    setValue("startServiceTime", new Date().toString())
  }

  useEffect(() => {
    if(!!errors.startServiceTime || !!errors.endServiceTime) {
      toast(
        <ToastContainer> 
          <Typography style={{paddingTop: 10, paddingBottom: 10}} size="small" color="white">Você precisa concluir o processo de atendimento para continuar</Typography>
          <MdClose size={24} color='white'/>
        </ToastContainer>,
        {
          icon: <MdHighlightOff size={24} color='white'/>,
          style: {
            background: '#F67D88',
            paddingLeft: '1rem',
            paddingRight: '1rem',
            paddingTop: 0,
            paddingBottom: '0.25rem',
            borderRadius: '0 0 0.5rem 0.5rem',
            color: 'white',
            width: '375px',
            margin: '0px'
          },
        }
      );
    }
  }, [errors])

  useEffect(() => {
     let urlBase = window.location.host;
     if (urlBase == 'localhost:3000' ){

        setUrlBackend('http://crefisamais.local:8080')

     } else if(urlBase ==  'exclusaocontad.crefisa.com.br'){

        setUrlBackend('https://www-d.crefisamais.com.br')

     } else if(urlBase ==  'exclusaocontah.crefisa.com.br'){

        setUrlBackend('https://www-h.crefisamais.com.br')

     }else{

        setUrlBackend('https://www.crefisamais.com.br')

     } 

  }, [])

  useEffect(() => {
    document.title = "Controle de Atendimento";
  }, [location]);

  return (
    <Container>
      <Content>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <TitleContainer>
            <Typography size="large" weight="bold">Dados Atendimento</Typography>
            <Typography>Precisamos de alguns dados para prosseguir com seu atendimento.</Typography>
            <Typography>Problemas no atendimento? Reinicie o atendimento <Button styleType="link" type="button" onClick={() => window.location.reload(false)}>aqui</Button>.</Typography>
            <InputContainer>
              <Input.WrapperStandard register={register} name="storeId" label="Código da loja" mask="storeId" error={errors?.storeId?.message}/>
              <Input.WrapperStandard register={register} name="password" label="Senha" mask="passCode" error={errors?.password?.message}/>
              <Input.WrapperStandard register={register} name="cpf" label="CPF" mask="cpf" error={errors?.cpf?.message}/>
              <Input.WrapperStandard register={register} name="arrivalTime" label="Horário de chegada" mask="hour" error={errors?.arrivalTime?.message} placeholder="hh:mm" disabled={!!watch("startServiceTime") && !errors?.arrivalTime}/>
              <Button wFull type="button" onClick={() => startService()} disabled={!!watch("startServiceTime")}>Começar atendimento</Button>
              <Typography weight="bold">{ watch("startServiceTime") && new Date(watch("startServiceTime")).toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' })}</Typography>
              <Button wFull type="button" onClick={() => setValue("endServiceTime", new Date().toString())} disabled={!!watch("endServiceTime") || !watch("startServiceTime")}>Finalizar atendimento</Button>
              <Typography weight="bold">{ watch("endServiceTime") && new Date(watch("endServiceTime")).toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' })}</Typography>
            </InputContainer>
          </TitleContainer>
          <ButtonContainer>
            <Button wFull disabled={isSubmitting || !watch("endServiceTime")}>Continuar</Button>
          </ButtonContainer>
        </Form>
      </Content>
    </ Container>
  )
}

export default UnsubscribeScreen